import axios from 'axios';
import config from '../config.js';

const loading = new Event('loading');
const notLoading = new Event('notLoading');

export default {
  waitTime: 200,
  request(method, uri, data, responseType) {
    window.dispatchEvent(loading);

    const serverURI = function () {
      if (window.location.hostname === 'localhost') return config.serverURI[1];
      else return config.serverURI[0];
    };
    const url = serverURI() + uri;

    let formData = new FormData();
    if (!(data instanceof FormData) && method === 'POST') {
      for (const key in data) {
        formData.append(key, data[key]);
      }
    } else {
      formData = data;
    }

    const instance = axios.create({
      withCredentials: true,
    });

    const axiosReq = {
      method,
      url,
    };
    axiosReq[method === 'POST' ? 'data' : 'params'] = formData;
    if (responseType) axiosReq.responseType = responseType;

    return instance
      .request(axiosReq)
      .then((res) => {
        window.dispatchEvent(notLoading);
        return res.data;
      })
      .catch((error) => {
        window.dispatchEvent(notLoading);
        if (error.response.status === 401) {
          window.location.href = '/login';
        }
        throw error;
      });
  },
  post(uri, data = null, responseType = null) {
    return this.request('POST', uri, data, responseType);
  },
  get(uri, data = null, responseType = null) {
    return this.request('GET', uri, data, responseType);
  },
  outsideRequest(url) {
    window.dispatchEvent(loading);
    const instance = axios.create({
      withCredentials: true,
    });
    const axiosReq = {
      method: 'GET',
      url,
    };
    return instance
      .request(axiosReq)
      .then((res) => {
        window.dispatchEvent(notLoading);
        return res.data;
      })
      .catch((error) => {
        window.dispatchEvent(notLoading);
        throw error;
      });
  },
};